// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".request-info[data-v-789df046] {\n  color: rgba(0, 0, 0, 0.88);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px;\n}\n.borderCard[data-v-789df046] {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.borderBottom[data-v-789df046]{\n  border-bottom: 1px solid var(--colorSplit, rgba(0, 0, 0, 0.06));\n}\n", ""]);
// Exports
module.exports = exports;
